// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

import Rootstore from '../index'
import DataStorageStoreBase from '../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DSPatientElementProps {
  id?: string
  group_key?: string
  patient_id?: string
  patient_name?: string
  patient_sex?: string
  patient_birth_date?: string
  study_folder_count?: number
  study_count?: number
  series_folder_count?: number
  series_count?: number
  sop_instance_count?: number
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStoragePatientStore extends DataStorageStoreBase<DSPatientElementProps> {
  totalCount: number = 0
  elements: Array<DSPatientElementProps> = []
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({ storeName: 'DS_StudyStore', apiSubUrl: 'dcm/patients', _root: root })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      _setTotalCount: action,
      setElements: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElement = async (id: string) => {
    return await super.get(id)
  }

  getElements = async (path: string) => {
    const rtnData = await super.getAll(path)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as Array<DSPatientElementProps>
  }

  addElement = async (element: DSPatientElementProps) => {
    const newElement = await super.add(element)
    return newElement.id
  }

  removeElement = async (id: string) => {
    return await super.remove(id)
  }

  updateElement = async (id: string, element: DSPatientElementProps) => {
    const updatedElement = await super.update(id, element)
    return updatedElement.id
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<DSPatientElementProps>) => {
    this.elements = elements
  }
}
